import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/index'
  },
  {
    path: '/index',
    name: 'Index',
    component: () => import('@/views/home/index.vue'),
  },
  {
    path: '/a/about',
    name: 'About',
    component: () => import('@/views/about/index.vue'),
  },
  {
    path: '/a/contact',
    name: 'Contact',
    component: () => import('@/views/contact/index.vue'),
  },
  {
    path: '/a/anli',
    name: 'Anli',
    component: () => import('@/views/anli/index.vue'),
  },
  {
    path: '/a/anli/detail',
    name: 'anli-detail',
    component: () => import('@/views/anli/detail.vue'),
  },
  {
    path: '/a/anli/dssj',
    name: 'Dssj',
    component: () => import('@/views/anli/dssj/index.vue'),
  },
  {
    path: '/a/anli/weixin',
    name: 'Weixin',
    component: () => import('@/views/anli/weixin/index.vue'),
  },
  {
    path: '/a/anli/wzjs',
    name: 'Wzjs',
    component: () => import('@/views/anli/wzjs/index.vue'),
  },
  {
    path: '/a/anli/wzyx',
    name: 'Wzyx',
    component: () => import('@/views/anli/wzyx/index.vue'),
  },
  {
    path: '/a/fangan/',
    name: 'Fangan',
    component: () => import('@/views/fangan/index.vue'),
  },
  {
    path: '/a/fangan',
    name: 'Fangan',
    component: () => import('@/views/fangan/index.vue'),
  },
  {
    path: '/a/fangan/detail',
    name: 'fangan-detail',
    component: () => import('@/views/fangan/detail.vue'),
  },
  {
    path: '/a/zhishi',
    name: 'Zhishi',
    component: () => import('@/views/zhishi/index.vue'),
  },
  {
    path: '/a/zhishi/detail',
    name: 'Zhishi-detail',
    component: () => import('@/views/zhishi/detail/index.vue'),
  },
  {
    path: '/a/zhishi/app',
    name: 'Zhishi-app',
    component: () => import('@/views/zhishi/app/index.vue'),
  },
  {
    path: '/a/zhishi/dianshang',
    name: 'Zhishi-dianshang',
    component: () => import('@/views/zhishi/dianshang/index.vue'),
  },
  {
    path: '/a/zhishi/ruanjian',
    name: 'Zhishi-ruanjian',
    component: () => import('@/views/zhishi/ruanjian/index.vue'),
  },
  {
    path: '/a/zhishi/tuiguang',
    name: 'Zhishi-tuiguang',
    component: () => import('@/views/zhishi/tuiguang/index.vue'),
  },
  {
    path: '/a/zhishi/wangzhan',
    name: 'Zhishi-wangzhan',
    component: () => import('@/views/zhishi/wangzhan/index.vue'),
  },
  {
    path: '/a/zhishi/xiaochengxu',
    name: 'Zhishi-xiaochengxu',
    component: () => import('@/views/zhishi/xiaochengxu/index.vue'),
  },
  {
    path: '/a/kehu',
    name: 'Kehu',
    component: () => import('@/views/kehu/index.vue'),

  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
